import { useEffect, useState } from 'react';

const QUERY = '(max-width: 768px)';

/** True on phones (and small tablets), where the chat fills the screen. */
export const isPhone = () => typeof window !== 'undefined' && Boolean(window.matchMedia) && window.matchMedia(QUERY).matches;

export const usePhone = () => {
  const [phone, setPhone] = useState(isPhone);
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const query = window.matchMedia(QUERY);
    const onChange = () => setPhone(query.matches);
    if (query.addEventListener) query.addEventListener('change', onChange);
    else if (query.addListener) query.addListener(onChange);
    return () => {
      if (query.removeEventListener) query.removeEventListener('change', onChange);
      else if (query.removeListener) query.removeListener(onChange);
    };
  }, []);
  return phone;
};
